/**
 * dateToTest example: 21st Oct 2015
 */
export const isDateBeforeToday = (dateToTest: string) => {
    const dateToTestDate = Date.parse(dateToTest.replace(/(st|nd|rd|th)/, ' '));

    return dateToTestDate <= Date.now();
};
